import axios from "axios";
import moment from "moment";

/**
 * @classdesc Handler formulaire de paiement Lyra
 * @kind class
 * @export
 * @class Lyra_Payment
 */
export default class Lyra_Payment {
    accept_ip_wire = false;
    commande_infos;
    id_boutique;
    endpoint;
    publicKey;
    formToken;

    /**
     * Creates an instance of Lyra_Payment.
     * @constructs
     * @kind function
     * @memberof Lyra_Payment
     */
    constructor() { }

    async init() {
        let res = await axios.post("/lyra_payment/init.php", this.commande_infos);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.set(res.data);
            return await true;
        }
    }

    set_payments_methods(module = undefined, reservation = undefined) {
        if (!module || !reservation) return;
        // Si le module n'accepte pas le virement, on ne propose pas le paiement par virement
        if (!module.has_metadata("payment_method_ip_wire") || module.get_metadata("payment_method_ip_wire") == "0") {
            return;
        }
        // Si le ip_wire_date_max du module est dépassée, on ne propose pas le paiement par virement
        let current_date = moment().format("YYYY-MM-DD");
        let date_max_ip_wire = moment(module.get_metadata("ip_wire_date_max")).format("YYYY-MM-DD");
        if (current_date >= date_max_ip_wire) {
            return;
        }
        // Si le ip_wire_nb_inscriptions_min du module est supérieure au nombre d'inscrits, on ne propose pas le paiement par virement
        let ip_wire_nb_inscriptions_min = module.get_metadata("ip_wire_nb_inscriptions_min");
        let nb_inscrits = reservation.inscriptions.length;
        if (parseInt(ip_wire_nb_inscriptions_min) > 0 && nb_inscrits < parseInt(ip_wire_nb_inscriptions_min)) {
            return;
        }
        // Si le ip_wire_total_min du module est supérieure au total, on ne propose pas le paiement par virement
        let ip_wire_total_min = module.get_metadata("ip_wire_total_min");
        let total = reservation.prix_total;
        if (parseFloat(ip_wire_total_min) > 0 && total < parseFloat(ip_wire_total_min)) {
            return;
        }

        // Sinon on propose le paiement par virement
        this.accept_ip_wire = true;


    }

    set_payments_methods_for_request_payment(module = undefined, request = undefined) {
        if (!module || !request) return;
        if (request.uuid_commande == "631462119772") {
            this.accept_ip_wire = true;
            return;
        }
        return false;
    }

    set_payments_methods_for_resend_payment_request(module = undefined, commande = undefined) {
        if (!module || !commande) return;
        if (commande.id == 57242) {

            this.accept_ip_wire = true;
            return;
        }
        // Si le module n'accepte pas le virement, on ne propose pas le paiement par virement
        if (!module.has_metadata("payment_method_ip_wire") || module.get_metadata("payment_method_ip_wire") == "0") {
            return;
        }
        // Si le ip_wire_date_max du module est dépassée, on ne propose pas le paiement par virement
        let current_date = moment().format("YYYY-MM-DD");
        let date_max_ip_wire = moment(module.get_metadata("ip_wire_date_max")).format("YYYY-MM-DD");
        if (current_date >= date_max_ip_wire) {
            return;
        }

        // Si le ip_wire_total_min du module est supérieure au total, on ne propose pas le paiement par virement
        let ip_wire_total_min = module.get_metadata("ip_wire_total_min");
        let total = commande.prix_total;
        if (parseFloat(ip_wire_total_min) > 0 && total < parseFloat(ip_wire_total_min)) {
            return;
        }

        // Sinon on propose le paiement par virement
        this.accept_ip_wire = true;
    }

    async init_amend_options() {
        let res = await axios.post("/lyra_payment/init_amend_options.php", this.commande_infos);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.set(res.data);
            return await true;
        }
    }

    async init_dossard_bourse() {
        let res = await axios.post("/lyra_payment/init_dossard_bourse.php", this.commande_infos);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.set(res.data);
            return await true;
        }
    }

    async init_changement_parcours() {
        let res = await axios.post("/lyra_payment/init_changement_parcours.php", this.commande_infos);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.set(res.data);
            return await true;
        }
    }

    async init_payment_request() {
        let res = await axios.post("/lyra_payment/init_payment_request.php", this.commande_infos);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.set(res.data);
            return await true;
        }
    }



    set(data) {
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
    }

    set_commande_infos(uuid, amount, mail, reservation) {
        this.commande_infos = {

            "amount": amount,
            "orderId": uuid,
            "customer": {
                "email": mail
            },
            "metadata": {
                "reservation": JSON.stringify(reservation)
            },
            "paymentMethods": ["CARD"],
        };

        if (this.accept_ip_wire) {
            this.commande_infos["paymentMethods"] = ["CARD", "IP_WIRE"];
        }

    }

    get_accepted_payment_methods() {
        let accepted = "CARDS";
        if (this.accept_ip_wire) {
            accepted += ",IP_WIRE";
        }
        return accepted;
    }

    set_response(response) {
        this.response = response;
    }

    /**
     * Vérifie la signature de la réponse lyra
     *
     * @param {*} response
     * @return {*} 
     * @memberof Lyra_Payment
     */
    async verify_response_hash(response) {
        let res = await axios.post("/lyra_payment/verify_response_hash.php", response);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            return await true;
        }
    }

}